import { themeColors } from '../theme/theme';
import { Icon } from '.';

/**
 * SortSelect reusable component
 * @param {Object} props
 * @param {string[]} props.options - Array of sort option labels
 * @param {string} props.value - Currently selected value
 * @param {function} props.onChange - Callback when a sort is selected
 * @param {object} [props.style] - Optional style override for the container
 */
export function SortSelect({ options, value, onChange, style }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, ...style }}>
      <Icon
        name="SortRounded"
        style={{
          fontSize: 20,
          color: themeColors.primaryColor,
          verticalAlign: 'middle',
        }}
      />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          borderRadius: 8,
          padding: '4px 10px',
          fontWeight: 600,
          color: themeColors.primaryColor,
          border: `1.5px solid ${themeColors.primaryColor}22`,
          background: '#fff',
          outline: 'none',
          fontSize: 15,
          minWidth: 90,
        }}
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option.charAt(0).toUpperCase() + option.slice(1)}
          </option>
        ))}
      </select>
    </div>
  );
}
